import { Fragment, useEffect, useState } from "react";
import { Card, CardHeader, Col, Row, CardBody, Input, Button, Table, Modal, ModalBody, InputGroup, InputGroupAddon, InputGroupText, ModalHeader } from "reactstrap";
import { translate } from "react-switch-lang";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import styles from "./country.module.scss";
import AddSetting from "../add-setting/addSetting";
import { CountryDto } from "../../../models/countryDto";
import { TypeSetting } from "../../../models/typeSetting";

function Country(props: any) {
  toast.configure();
  const httpClient = useHttpClient(true);
  const [country, setCountry] = useState<CountryDto>(new CountryDto());
  const [isOncreate, setIsOncreate] = useState<boolean>(true);
  const [listCountry, setListCountry] = useState<CountryDto[]>([]);
  const [listFiltredCountry, setListFiltredCountry] = useState<CountryDto[]>([]);
  const [openModalEditSupport, setOpenModalEditSupport] = useState<boolean>(false);

  const toggle = (data: CountryDto) => {
    setOpenModalEditSupport(!openModalEditSupport);
    setCountry(data);
  };

  const handleDeleteCountry = (countryId: number) => {
    SweetAlert.fire({
      title: props.t("country.message_confirmation_delete_country"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/country/" + countryId).then(response => {
          if (response.data) {
            toast.success(String(props.t("message_toastr_delete")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            handleGetCountry();
          } else {
            toast.error(String(props.t("country.message_toastr_cannot_delete_country")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
          }
        });
      } else {
      }
    });
  };

  const handleGetCountry = () => {
    httpClient.current?.get("/country").then(response => {
      setListCountry(response.data);
      setListFiltredCountry(response.data);
    });
  };

  const handleClickOnUpdate = (data: CountryDto, index: number) => {
    setIsOncreate(false);
    toggle(data);
  };

  useEffect(() => {
    httpClient.current?.get("/country").then(response => {
      setListCountry(response.data);
      setListFiltredCountry(response.data);
    });
  }, [httpClient]);

  const handleSearch = (value: string) => {
    setListFiltredCountry(
      listCountry.filter(thematic => thematic.titleFrancais.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || thematic.titleAnglais.toLocaleLowerCase().includes(value.toLocaleLowerCase())),
    );
  };

  return (
    <Fragment>
      <Card>
        <CardHeader className={styles["parametrage-card-header"]}>
          <Row>
            <Col md={12}>
              <div className={styles["parametrage-card-header-input"]}>
                <div className={styles["parametrage-card-inputs"]}>
                  <InputGroup className={styles["categories-search-input-group"]}>
                    <Input onChange={e => handleSearch(e.target.value)} type="search" placeholder={String(props.t("filters.input_placeholder_search"))} />
                    <InputGroupAddon addonType="append">
                      <InputGroupText className={styles["categories-search-input-group-text"]}>
                        <i className={"fa fa-search " + styles["categories-search-input-group-icon"]} />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </div>
                <Button
                  outline
                  color="success"
                  className={styles["categories-add-btn"]}
                  onClick={() => {
                    setIsOncreate(true);
                    toggle(new CountryDto());
                  }}
                >
                  {props.t("country.button_add_country")}
                </Button>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className={styles["parametrage-card-body"]}>
          {listCountry.length === 0 ? (
            <div className="text-center">
              <div className={styles["no-data"]}>{props.t("country.message_no_country_title")} </div>
              <div className={styles["no-data"]}>{props.t("country.message_no_country_subtitle")}</div>
            </div>
          ) : (
            <Fragment>
              {
                <Table className={styles["parametrage-card-body"]}>
                  <thead>
                    <tr>
                      <th className={styles["document-table-nom"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_image")}
                        </span>
                      </th>
                      <th className={styles["document-table-thematique"]} scope="col">
                        {props.t("param_table_header.label_title_fr")}
                      </th>
                      <th className={styles["document-table-type"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_title_en")}
                        </span>
                      </th>

                      <th className={styles["document-table-actions"]} scope="col">
                        {props.t("param_table_header.actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listFiltredCountry.map((data: CountryDto, index: number) => (
                      <tr key={data.countryId}>
                        <td>
                          <img className={styles["parametrage-card-image"]} src={data.urlImage + "/preview"} alt="" />
                        </td>
                        <td className="align-middle">{data.titleFrancais}</td>
                        <td className="align-middle">{data.titleAnglais}</td>

                        <td className={`${styles["document-table-actions-icons"]} align-middle`}>
                          <div>
                            <i className={`${styles["parametrage-actions__btn-update"]}  fa fa-edit`} onClick={() => handleClickOnUpdate(data, index)} />
                            <i className={`${styles["parametrage-actions__btn-delete"]} fa fa-trash-o`} onClick={() => handleDeleteCountry(data.countryId)} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }
            </Fragment>
          )}
        </CardBody>
      </Card>
      <Modal isOpen={openModalEditSupport} size="lg">
        <ModalHeader toggle={() => toggle(new CountryDto())}>{isOncreate ? props.t("country.title_create_country") : props.t("country.title_update_country")}</ModalHeader>
        <ModalBody>
          <AddSetting toggle={toggle} handleGet={handleGetCountry} type={TypeSetting.COUNTRY} settingModal={country}></AddSetting>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default translate(Country);
